import { useStatsigClient, useStatsigUser } from '@statsig/react-bindings'
import { PLAYER_PLAYLISTS } from 'constants/featureFlags'
import useToken from 'utils/hooks/useToken'

const usePlayerPlaylists = () => {
  const { checkGate, isLoading } = useStatsigClient()
  const { user: statsigUser } = useStatsigUser()
  const { getUser } = useToken()
  const user = getUser()
  const expectedUserID = user?.playerid?.toString()

  if (!expectedUserID) {
    return { enabled: false, isLoading: false }
  }

  const isUserSyncPending =
    statsigUser?.userID?.toString() !== expectedUserID ||
    (statsigUser?.email || undefined) !== (user.email || undefined)

  if (isLoading || isUserSyncPending) {
    return { enabled: false, isLoading: true }
  }

  try {
    return { enabled: checkGate(PLAYER_PLAYLISTS), isLoading: false }
  } catch {
    return { enabled: false, isLoading: false }
  }
}

export default usePlayerPlaylists
